import { useAvisosTitulo } from "@/hooks/useAvisosTitulo";

/**
 * Faixa de avisos exibida logo após o título das janelas principais.
 * Hoje mostra o aviso de valores ocultados/simulados, mas aceita
 * quaisquer avisos registrados em @/lib/avisos-titulo.
 */
export function AvisosTitulo({ className = "" }: { className?: string }) {
  const { avisos } = useAvisosTitulo();
  if (avisos.length === 0) return null;
  return (
    <span className={`flex flex-wrap items-center gap-2 ${className}`}>
      {avisos.map((a) => (
        <span
          key={a.id}
          className="rounded px-2 py-0.5 text-xs font-semibold text-black"
          style={{ backgroundColor: a.tipo === "erro" ? "#FF8080" : "#FFFF80" }}
        >
          {a.texto}
        </span>
      ))}
    </span>
  );
}

export default AvisosTitulo;
